import axios from 'axios';
import authHeader from './authHeader';
import AuthService from './Auth.service'

let isRefreshing = false;

let failedQueue = [];

const processQueue = (error) => {
    failedQueue.forEach(prom => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve();
        }
    });

    failedQueue = [];
};

export default async function RetryPolicyForAxiosInterceptor(props) {

    const originalRequest = props.config;

    if (props.response.status === 401 && !originalRequest._retry) {
        if (isRefreshing) {
            return new Promise(function (resolve, reject) {
                failedQueue.push({ resolve, reject });
            })
                .then(() => {
                    originalRequest.headers = authHeader();
                    return axios(originalRequest);
                })
                .catch(err => {
                    return Promise.reject(err);
                });
        }

        originalRequest._retry = true;
        isRefreshing = true;

        return new Promise(function (resolve, reject) {
            AuthService.relogin()
                .then(() => {                 
                    originalRequest.headers = authHeader();
                    processQueue(null);
                    resolve(axios(originalRequest));
                })
                .catch(err => {
                    processQueue(err);
                    console.log('Expired Token');

                    reject(err);
                })
                .then(() => {
                    isRefreshing = false;
                });
        });
    }

    if (props.response.status === 404) {
        console.log(props);
    }

    return Promise.reject(props);

}